<template>
    <az-container class="componente-tabela">
        <v-data-table
            ref="Table"
            :headers="colunas"
            :items="lista"
            :loading="loading"
            :class="`${classTable} ${(lista.length === 0 && !loading) ? 'scrollbar-hidden' : ''} ${small ? '' : 'az-table-list'} ${desabilitaAlturaMaxima ? '' : 'altura-tabela'}`"
            :item-class="(param) => $emit('retornaClasseDoItem', param)"
            :options.sync="paginacaoInterna"
            :server-items-length="serverItemsLength"
            hide-default-footer
            hide-default-header
            item-key="id"
            @click:row="(...param) => $emit('clickRow', param)"
            @update:sort-by="atualizarSortBy"
            @update:sort-desc="atualizarSortDesc"
        >
            <template v-slot:header="{ props: { headers, options }, on }">
                <thead class="v-data-table-header" v-if="(lista.length > 0 && !loading) || loading">
                    <tr>
                        <th
                            v-for="(header, indexHeader) in headers"
                            :key="indexHeader"
                            v-show="header.exibirColuna === undefined || header.exibirColuna === true"
                            class="sortable"
                            :style="`${header.width >= 0 ? `width: ${header.width}px` : ''}`"
                            :class="montaClassHeader(header, options)"
                        >
                            <span>
                                {{ header.text }}
                            </span>

                            <i
                                v-if="header.type !== 'button' && header.exibirOrdenacao"
                                aria-hidden="true"
                                class="v-icon notranslate v-data-table-header__icon material-icons theme--light"
                                style="font-size: 18px;"
                                @click="() => on.sort(header.value)"
                            >
                                arrow_upward
                            </i>
                        </th>
                    </tr>
                </thead>
            </template>

            <template v-slot:body="{ items, headers }">
                <tbody v-if="items.length > 0">
                    <tr v-for="(item, indexItem) in items" :key="indexItem">
                        <td
                            v-for="(header, indexHeader) in headers"
                            :key="indexHeader"
                            v-show="header.exibirColuna === undefined || header.exibirColuna === true"
                            :class="(['button', 'boolean'].includes(header.type) || header.alignCenter === true) ? 'text-center' : 'text-start'"
                        >
                            <span
                                v-if="header.type === 'boolean'"
                                class="d-flex justify-center align-center"
                                :class="header.class"
                            >
                                {{ capturarDadosObjeto(item, header.value) ? "Sim" : "Não" }}
                            </span>

                            <span
                                v-else-if="header.type === 'icone' && (header.visible || true)"
                                :class="header.class"
                            >
                                <span>
                                     <v-icon
                                         v-if="capturarDadosObjeto(item, header.value) || header.sempreExiberIcone"
                                         class="mr-1"
                                         :class="header.classIcone"
                                         :color="header.colorIcone"
                                         :size="header.sizeIcone || 13"
                                     >
                                         {{ header.icone(capturarDadosObjeto(item, header.value), item) }}
                                     </v-icon>

                                    <span  :class="(typeof header.classText === 'function') ? header.classText(item) : header.classText">
                                        {{ (header.formatter !== undefined)
                                            ? header.formatter(capturarDadosObjeto(item, header.value), item)
                                        : capturarDadosObjeto(item, header.value)
                                        }}
                                    </span>
                                </span>
                            </span>

                            <span
                                v-else-if="header.type === 'button'"
                                class="d-flex justify-center align-center"
                                :class="header.class"
                                v-show="header.visible === undefined || header.visible(item)"
                            >
                                <span
                                    v-for="(button, indexButton) in header.list"
                                    :key="indexButton"
                                    v-show="button.visible === undefined || button.visible(item)"
                                >

                                   <v-btn
                                       v-if="!button.type"
                                       icon
                                       :color="button.color"
                                       :dark="button.dark || false"
                                       @click="button.clickBtn(item)"
                                   >
                                       <v-icon
                                           :color="button.color"
                                           :class="button.class"
                                           :size="button.size || 16"
                                       >
                                           {{ button.icone }}
                                       </v-icon>
                                   </v-btn>

                                    <v-tooltip
                                        v-else-if="button.type === 'button-tooltip'"
                                        max-width="220"
                                        top
                                    >
                                        <template v-slot:activator="{ on }">
                                            <div v-on="on">
                                               <v-btn
                                                   icon
                                                   :color="button.color"
                                                   :dark="button.dark || false"
                                                   @click="button.clickBtn(item)"
                                               >
                                                   <v-icon
                                                       :color="button.color"
                                                       :class="button.class"
                                                       :size="button.size || 16"
                                                   >
                                                       {{ button.icone }}
                                                   </v-icon>
                                               </v-btn>
                                            </div>
                                        </template>

                                        {{ button.mensagemTooltip }}
                                    </v-tooltip>

                                    <v-menu
                                        v-else-if="button.type === 'menu' && verificaExibeItensMenu(button, item)"
                                        :offset-y="button.offset_y || false"
                                        :offset-x="button.offset_x || false"
                                        :left="button.left || false"
                                        :right="button.right || false"
                                        :top="button.top || false"
                                        :bottom="button.bottom || false"
                                        :open-on-hover="button.trigger === 'hover'"
                                    >
                                        <template v-slot:activator="{ on, attrs }">
                                            <div
                                                v-bind="attrs"
                                                v-on="on"
                                                class="d-flex justify-center align-center"
                                            >
                                                <v-btn
                                                    :color="button.color"
                                                    :dark="button.dark || false"
                                                    icon
                                                >
                                                     <v-icon
                                                         :color="button.color"
                                                         :class="button.class"
                                                         :size="button.size || 16"
                                                     >
                                                        {{ button.icone }}
                                                    </v-icon>
                                                </v-btn>

                                                <div>
                                                    {{ typeof button.text === 'function' ? button.text(item) : button.text }}
                                                </div>
                                            </div>
                                        </template>

                                        <v-list class="py-3">
                                            <v-list-item
                                                v-for="(itemMenu, indexItemMenu) in pegarListMenuButton(button.listMenu, item)"
                                                :key="indexItemMenu"
                                                :class="itemMenu.classItem"
                                                v-show="itemMenu.visible === undefined || itemMenu.visible(item)"
                                                @click="(itemMenu.clickBtn !== undefined) ? itemMenu.clickBtn(item) : () => {}"
                                            >
                                                <v-list-item-title
                                                    :class="itemMenu.classItemTitle || 'd-flex justify-start align-center'"
                                                    style="gap: 5px"
                                                >
                                                     <v-icon
                                                         v-if="itemMenu.icone"
                                                         size="14"
                                                         :color="itemMenu.colorIcone"
                                                     >
                                                         {{ itemMenu.icone }}
                                                     </v-icon>
                                                    {{ itemMenu.text }}
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </span>
                            </span>

                            <span
                                v-else-if="header.type === 'tooltip-list'"
                            >
                                <v-tooltip :disabled="disabledTooltipLista(item, header)" max-width="220" bottom>
                                    <template v-slot:activator="{ on }">
                                        <div
                                            v-on="on"
                                            class="d-inline-block text-truncate"
                                            :class="(typeof header.class === 'function') ? header.class(item) : header.class"
                                        >
                                            <span :class="(typeof header.classText === 'function') ? header.classText(item) : header.classText">
                                                {{ formatarListaTooltip(item, header) }}
                                            </span>
                                        </div>
                                    </template>

                                    {{ formatarMensagemTooltipLista(capturarDadosObjeto(item, header.value), header.configList) }}
                                </v-tooltip>
                            </span>
                            <span
                                v-else
                                v-show="item.visible === undefined || item.visible(item)"
                                :class="(typeof header.class === 'function') ? header.class(item) : header.class">
                                <v-tooltip nudge-top="0" top transition="scale-transition" origin="center center"
                                           max-width="300">
                                   <template v-slot:activator="{ on }">
                                        <span v-on="on"
                                              class="d-inline-block text-truncate"
                                              :style="`${header.width >= 0 ? `max-width: ${header.width}vw` : ''}`"
                                              :class="(typeof header.classText === 'function') ? header.classText(item) : header.classText">
                                            {{ ((header.formatter !== undefined)
                                                ? header.formatter(capturarDadosObjeto(item, header.value), item)
                                                : capturarDadosObjeto(item, header.value)) || '-' }}
                                        </span>
                                   </template>
                                        <span :class="(typeof header.classText === 'function') ? header.classText(item) : header.classText">
                                            {{ ((header.formatter !== undefined)
                                                ? header.formatter(capturarDadosObjeto(item, header.value), item)
                                                : capturarDadosObjeto(item, header.value)) || '-' }}
                                        </span>
                                </v-tooltip>
                            </span>
                        </td>
                    </tr>
                </tbody>

                <thead v-else-if="items.length === 0 && !loading">
                    <tr>
                        <th colspan="10" class="column text-center" style="border: none !important; font-size: 16px !important;">
                            <slot v-if="$slots.listagemVazia" name="listagemVazia"/>

                            <span v-else>
                                Nenhum item encontrado
                            </span>
                        </th>
                    </tr>
                </thead>
            </template>
        </v-data-table>

        <paginacao
            v-if="paginacaoAtiva"
            :paginacao-interna="paginacaoInterna"
            :paginas="paginas"
            :total-itens="totalItens"
            @resetaPage="$emit('resetaPage')"
            @aoMudarPagina="(param) => $emit('aoMudarPagina', param)"
        />
    </az-container>
</template>

<script>
    import Paginacao from '@/views/components/tabela/Paginacao.vue'

    export default {
        name: 'Tabela',

        components: {
            Paginacao,
        },

        props: {
            lista: {
                type: Array,
                required: true
            },
            colunas: {
                type: Array,
                required: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            classTable: {
                type: String,
            },
            paginacaoAtiva: {
                type: Boolean,
                default: true
            },
            paginas: {
                type: Number,
                default: 0,
            },
            totalItens: {
                type: Number,
                default: 0,
            },
            paginacaoTabela: {
                type: Object,
                required: false,
                default: () => ({
                    itemsPerPage: 10,
                    rowsPerPage: 10,
                    page: 1,
                })
            },
            small: {
                type: Boolean,
                required: false,
                dfault: false,
            },
            desabilitaAlturaMaxima: {
                type: Boolean,
                required: false,
                default: false,
            }
        },

        computed: {
            serverItemsLength() {
                if (!this.paginacaoAtiva) return -1

                return this.totalItens
            },
            paginacaoInterna: {
                get () { return this.paginacaoTabela },
                set (value) { return value }
            },
        },

        watch: {
            lista: {
                handler() {
                    if (!this.paginacaoAtiva)
                        this.paginacaoInterna.itemsPerPage = this.lista.length
                },
                deep: true
            }
        },

        methods: {
            capturarDadosObjeto(objeto, caminhoObjeto) {
                const propriedadesCaminhos = caminhoObjeto.split('.')
                let valor = objeto

                propriedadesCaminhos.forEach((p) => {
                    if (valor !== undefined && valor !== null) {
                        valor = valor[p]
                    }
                })

                return valor
            },
            atualizarSortBy(param) {
                this.paginacaoInterna.sortBy = param

                if (param.length === 0) {
                    if (this.paginacaoInterna.sortDesc !== undefined) this.paginacaoInterna.sortDesc = []
                    if (this.paginacaoInterna.descending !== undefined) this.paginacaoInterna.descending = false
                }

                this.$emit('atualizarSortBy', this.paginacaoInterna)
            },
            atualizarSortDesc(param) {
                if (this.paginacaoInterna.sortDesc !== undefined) this.paginacaoInterna.sortDesc = param
                if (this.paginacaoInterna.descending !== undefined) this.paginacaoInterna.descending = param.length === 0 ? false : param[0]

                this.$emit('atualizarSortDesc', this.paginacaoInterna)
            },
            pegarListMenuButton(lista, item) {
                return typeof lista === 'function' ? lista(item) : lista
            },
            verificaExibeItensMenu(dadosButton, item) {
                const listaMenu = this.pegarListMenuButton(dadosButton.listMenu, item)

                for (let i = 0; i < listaMenu.length; i++) {
                    const itemMenu = listaMenu[i]
                    if (itemMenu.visible === undefined || itemMenu.visible(item)) return true
                }

                return false
            },
            montaClassHeader(header, options) {
                let classHeader = ''

                classHeader = (['button', 'boolean'].includes(header.type) || header.alignCenter === true) ? 'text-center ' : 'text-start '

                if (options.sortBy.includes(header.value))
                    classHeader += `active ${options.sortDesc[0] ? 'desc' : 'asc'}`

                return classHeader
            },
            disabledTooltipLista(item, header) {
                const lista = this.capturarDadosObjeto(item, header.value)
                const { keyMostraLabelPadrao, limit = null } = header.configList

                const mostraLabelPadrao = (keyMostraLabelPadrao && item[keyMostraLabelPadrao])
                const listaVazia = !lista || lista.length === 0

                return mostraLabelPadrao || listaVazia || (limit === null) || (lista.length <= limit)
            },
            formatarListaTooltip(item, header) {
                const lista = this.capturarDadosObjeto(item, header.value)
                const { keyMostraLabelPadrao, labelPadrao = '-', limit = null, separator = ', ' } = header.configList

                if ((keyMostraLabelPadrao && item[keyMostraLabelPadrao]) || (!lista || lista.length === 0))
                    return labelPadrao

                return limit !== null && lista.length > limit ? `${lista.filter((_, index) => index < limit).join(separator)}.. +${lista.length - limit}` : lista.join(separator)
            },
            formatarMensagemTooltipLista(lista, { separator = ', ' }) {
                return lista.join(separator)
            }
        }
    }
</script>

<style lang="stylus">
    .componente-tabela
        .scrollbar-hidden
            .v-data-table__wrapper
                overflow: hidden;

        .altura-tabela
            min-height 58vh !important
</style>